import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 14a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 1 1 1.414-1.414L10 11.586l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5A.997.997 0 0 1 10 14",
  fillRule: "evenodd"
});

var SvgChevronDownMinor = function SvgChevronDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgChevronDownMinor as S };
